class INTENT.widgets.CreativeOnArchiveWarning

  @ATTR_NAME: "data-widget-creative-on-archive-warn"

  @ATTR_ARCHIVE_TARGET: "data-archive-target"
  @ATTR_ACTIVE_CAMPAIGNS: "data-active-campaigns-with-this-creative"
  @ATTR_ACTIVE_CAMPAIGNS_TARGET: "data-active-campaigns-with-this-creative-target"

  @forcedArchive = no
  @form = null

  constructor: (@el) ->
    @s = @.constructor

    if not @el.is "[#{@s.ATTR_ACTIVE_CAMPAIGNS_TARGET}]"
      return

    try
      activeCampaigns = JSON.parse($ @el.attr "#{@s.ATTR_ACTIVE_CAMPAIGNS_TARGET}"
        .attr @s.ATTR_ACTIVE_CAMPAIGNS
      )
    catch
      return

    # turn off confirm dialog
    @el.get(0).onclick = ->
    # turn off admin-delete-button.coffee handler
    if @el.is "[data-delete-object]"
      @el.off 'click'

    @el.on 'click', (e) =>
      @el = $ e.currentTarget
      if @s.forcedArchive
        return
      e.preventDefault()
      @initModal activeCampaigns

    $(INTENT.utils.Modal.SELECTOR_TEMPLATE_ID).off 'show.bs.modal'
    $(INTENT.utils.Modal.SELECTOR_TEMPLATE_ID).on 'show.bs.modal', ->
      $('.archive-info').tooltip()


  initModal: (activeCampaigns) =>
    rows = []
    tpl = INTENT.utils.Template
    warnAboutStopCampaigns = _.size(_.filter(activeCampaigns, (item) ->
      return item.is_only
    )) > 0
    modalSettings =
      title: __('creative_archive_warning_title')
      body: ''
      size: 'large'
      buttons: [
        attr:
          class: "cr-forced-archive btn btn-danger pull-left"
          type: "button"
        click: =>
          @s.forcedArchive = on
          $('.cr-forced-archive').showLoader()
          @performArchiveAction "#{@el.attr('href')}#{INTENT.utils.Url.asString {forced: 1}}"
        text: if warnAboutStopCampaigns then __('creative_archive_warning_btn') else __('archive')
      ]

    $.each activeCampaigns, (id, cmp) ->
      if 'id' of cmp and 'name' of cmp and 'ar' of cmp
        td = ''
        td += tpl.get_td_row "##{cmp.id}", {style: 'width:10%;'}
        td += tpl.get_td_row (tpl.wrap_link "/campaigns/advertisers/#{cmp.ar}/campaigns/edit/#{cmp.id}", cmp.name, '', '_blank')
        td += tpl.get_td_row (if cmp.is_only then "#{__('yes')} <i title='#{__("creative_onarchive_campaign_will_stop")}' class='archive-info fa fa-info-circle opacity-dynamic'></i>" else __('no')), {style: 'text-align:center;width:25%;'}
        rows.push tpl.get_tr_row td

    headRows = [
      tpl.get_td_row "<strong>id</strong>", {style: 'width:10%;'}
      tpl.get_td_row "<strong>#{__('name')}</strong>"
      tpl.get_td_row "<strong>#{__('campaigns.will_be_stopped')}?</strong>", {style: 'text-align:center;width:25%;'}
    ].join('')

    creativeString = ''
    parent = @el.parents 'tr'
    if parent.length and parent.data('creativesId') and parent.data('creativesName')
      creativeString = "<strong>##{parent.data 'creativesId'} #{parent.data 'creativesName'}</strong>"

    body = [
      tpl.wrap_in_p __('active_campaigns_with_creative', {':creative': creativeString})
      tpl.get_table(headRows, rows.join(''))
    ]

    modalSettings.body += body.join ""
    INTENT.utils.Modal.show modalSettings

  performArchiveAction: (url) =>
    if -1 == url.indexOf '_ajax'
      window.location.href = url

    $.ajax({
      url: url
      method: 'POST'
    }).done (resp) =>
      @s.forcedArchive = no
      $('.cr-forced-archive').hideLoader()
      INTENT.utils.Modal.close()
      try
        # @see application/classes/Controller/Campaigns/Advertiser.php:1427
        if resp.payload? and resp.payload.modal?
          modal =
            title: resp.payload.modal.title
            body: resp.payload.modal.body

          INTENT.utils.Modal.show modal
        else if resp.notify? and resp.notify.type? and resp.notify.message?
          INTENT.utils.Notify.message resp.notify.message, resp.notify.type, {fadeOut: {delay: 5000}}
          if @el.is "[#{@s.ATTR_ARCHIVE_TARGET}]"
            $("#{@el.attr(@s.ATTR_ARCHIVE_TARGET)}").remove()
        else if resp.err? and resp.msg?
          modal =
            title: __('admin.creative.confirm.title')
            body: resp.msg
          INTENT.utils.Modal.show modal
      catch
